import {useEffect} from 'react';
import {useThree} from '@react-three/fiber';
import {useXRSessionVisibilityState} from '@react-three/xr';
import {useScreenshot} from 'hooks';
import {useARStore} from 'stores';
import {ARCoreComposite, ARCoreLighting, ARCoreReticle, ARCoreUI, ARModels} from '.';

interface IARCoreProps {
  onSessionChanged: (hasSession: boolean) => void;
}

const ARCore = ({onSessionChanged}: IARCoreProps) => {
  const camera = useThree(s => s.camera);
  const cameraRef = useARStore(s => s.cameraRef);
  const isModelInteractiveRef = useARStore(s => s.isModelInteractiveRef);
  const sessionActive = useXRSessionVisibilityState();
  const {handleScreenshot} = useScreenshot();

  useEffect(() => {
    isModelInteractiveRef.current = true;
  }, []);

  useEffect(() => {
    cameraRef.current = camera;
  }, [camera]);

  useEffect(() => {
    onSessionChanged(!!sessionActive);
  }, [sessionActive]);

  if (!sessionActive || !cameraRef.current) {
    return null;
  }
  return (
    <>
      <ARCoreUI onScreenshot={handleScreenshot} />
      <ARCoreLighting />
      <ARCoreReticle />
      <ARModels />
      <ARCoreComposite />
    </>
  );
};

export default ARCore;
